import { render, staticRenderFns } from "./ModalTelefone.vue?vue&type=template&id=e2faec06&scoped=true"
import script from "./ModalTelefone.vue?vue&type=script&lang=js"
export * from "./ModalTelefone.vue?vue&type=script&lang=js"
import style0 from "./ModalTelefone.vue?vue&type=style&index=0&id=e2faec06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2faec06",
  null
  
)

export default component.exports